import React, {useCallback, useEffect, useState, useMemo} from 'react';
import {
	Slider,
	Input,
	Button,
	Popover, Toast
} from '@kaleyra/emmy';
import { useTranslation } from 'react-i18next';
import PasswordValidator from "../components/PasswordValidatorDark";
import {validatePassword12To64} from "../../../../utils";
import Styles from "./modal.module.scss";

export type MapStateToPropsType = {
	params: any;
};

export type MapDispatchToPropsType = {
	onClose: () => void;
	editCredential : ( reqData:any,filters:any,keyForIdentifier:string,dynamicUrlData:string, cb?:(res: any, success: boolean)=> void ) => void;
};

const ChangePasswordModal: React.FC<MapStateToPropsType & MapDispatchToPropsType> = (
	{
		onClose,
		params,
		editCredential
	}) => {
	const [passwordPop, setPasswordPop] = useState<boolean>(false);
	const [confirmPassword, setConfirmPassword] = useState<undefined|string>(undefined);
	const [showPasswordMatch, setShowPasswordMatch] = useState<boolean>(false);
	const [changePass, setChangePass] = useState<boolean>(false);
	const [password, setPassword] = useState<undefined|string>(undefined);
	const { t } = useTranslation();

	const handleSave = useCallback(() => {
		if(!password) return;
		editCredential( params.selectedCredential,{
			credential_group_id:params.credentialGroupId,
			password
		}, "credential_id",
			params.selectedCredential.credential_id,
			(res:any,success:boolean)=>{
				if(success) Toast(t('KLR00490'),'success')
				else if(res?.data?.message) Toast(res?.data?.message,'error');
			});
		onClose();
	},[password]);

	const validatePasswordMatch = useMemo(()=>{
		return password === confirmPassword;
	},[password,confirmPassword]);

	const enableSaveButton = useMemo(() => {
		if(password == undefined)  return false;
		return validatePassword12To64(password) && password === confirmPassword;
	},[password,confirmPassword]);

	const invalidPasswordErrorLabel = useMemo(() =>{
		if(!changePass || password === undefined) return "";
		if(!validatePassword12To64(password)) return t('Invalid password');
		return undefined;
	},[changePass,password]);

	const renderFooter = useMemo(() => {
		return (
			<div className={Styles.footer}>
				<span className={Styles.cancelBtn}>
					<Button type="tertiary" onClick={onClose}>
						{t('mainCancel')}
					</Button>
				</span>
				<Button
					disabled={!enableSaveButton}
					type="primary"
					onClick={handleSave}
				>
					{t('mainSave')}
				</Button>
			</div>
		);
	},[enableSaveButton]);

	return (
		<Slider
			title={t('KLR00455')}
			containerId="root-modal"
			onClose={onClose}
			visibility={true}
			footer={renderFooter}
		>
			<div>
				<Popover
					visible={passwordPop}
					content={ <PasswordValidator password={password||""} /> }
					placement="left"
					color="#212B36"
				>
					<Input
						placeholder={t('KLR00457')}
						inputClassName={Styles.ipBox}
						className={Styles.ipBoxM1}
						label={t('KLR00457')}
						password={true}
						value={password}
						showBottomLabelSpace={ changePass && password!==undefined && !validatePassword12To64(password || "")}
						bottomLabelType={
							changePass && password!==undefined && !validatePassword12To64(password || "")? 'error' : undefined
						}
						bottomLabel={ invalidPasswordErrorLabel }
						onFocus={() => {
							setPasswordPop(true);
							setChangePass(false);
						}}
						onChange={(e: any) => {
							setPassword(e.target.value);
						}}
						onBlur={() => {
							setPasswordPop(false);
							setChangePass(true);
						}}
						autoComplete="new-password"
					/>
				</Popover>

				<Input
					placeholder={t('KLR00458')}
					inputClassName={Styles.ipBox}
					className={Styles.ipBoxM1}
					label={t('KLR00458')}
					password={true}
					iconRender={()=><></>}
					value={confirmPassword}
					showBottomLabelSpace={ showPasswordMatch && !validatePasswordMatch }
					bottomLabelType={ (showPasswordMatch && !validatePasswordMatch) ? "error" : undefined}
					bottomLabel={
						(showPasswordMatch && !validatePasswordMatch) ? t("passwords don't match") : false
					}
					onFocus={() => setShowPasswordMatch(false)}
					onBlur={() => setShowPasswordMatch(true)}
					onChange={(e: any) => {
						setConfirmPassword(e.target.value);
					}}
					autoComplete="new-password"
				/>
			</div>
		</Slider>
	);
};

export default ChangePasswordModal;
